/**
* User.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { cookieAvailable, getCookie } from '@ms/1ds-core-js';
var User = /** @class */ (function () {
    function User(coreConfig) {
        //Add MUID in user localId
        if (!coreConfig.disableCookiesUsage && cookieAvailable()) {
            var muidValue = getCookie('MUID');
            if (muidValue) {
                this.localId = 't:' + muidValue;
            }
        }
        //Add user language
        if (typeof navigator !== 'undefined') {
            var nav = navigator;
            this.locale = nav.userLanguage || nav.language;
        }
    }
    Object.defineProperty(User.prototype, "localId", {
        /**
         * The userId as known by the logging library.
         */
        get: function () {
            if (this._customLocalId) {
                return this._customLocalId;
            }
            var muidValue = getCookie('MUID');
            if (muidValue) {
                this.localId = 't:' + muidValue;
            }
            return undefined;
        },
        set: function (value) {
            this._customLocalId = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    return User;
}());
export { User };
//# sourceMappingURL=User.js.map